import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import BundleEditView from '@components/shared/bundles/BundleEditView';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

import operatorBundleService from '@services/operator/bundleService';

interface MerchantInventoryType {
  inventory_type?: { id: string; name: string };
}

interface OperatorDataValue {
  merchantInventoryTypes?: MerchantInventoryType[];
  merchantId?: string | null;
}

const BundleNewContent: React.FC = () => {
  const { merchantInventoryTypes, merchantId } = useOperatorData() as OperatorDataValue;
  const productService = useOperatorProductService();
  const inventoryTypes = (merchantInventoryTypes || [])
    .map(mit => mit.inventory_type)
    .filter(Boolean) as { id: string; name: string }[];

  // <MerchantSelect> 已在外層 gate `if (merchantId)`，本元件 mount 時 merchantId
  // 必為 string；這裡只是把 runtime invariant 在 TS 層表達出來（放在所有 hook 之後）。
  if (!merchantId) return null;

  return (
    <BundleEditView
      bundleService={operatorBundleService as any}
      productService={productService as any}
      inventoryTypes={inventoryTypes}
      role="operator"
      merchantId={merchantId}
    />
  );
};

const OperatorBundleNew: React.FC = () => (
  <MerchantSelect>
    <BundleNewContent />
  </MerchantSelect>
);

export default OperatorBundleNew;
